import React, {
  type ReactNode,
  type Ref,
  type SelectHTMLAttributes,
  useMemo,
} from "react";
import { Field, type Validator } from "redux-form";
import {
  type InputRef,
  InputRenderer,
} from "src/shared/forms/formrenderers/InputRenderer";
import type { IFormInputLabelRequired } from "src/shared/forms/inputs/IFormInput";
import { PleaseSelect } from "src/shared/forms/inputs/PleaseSelect";
import { combineReduxFormValidationRules } from "src/shared/forms/validations/combineReduxFormValidationRules";
import { required } from "src/shared/forms/validations/Required";

export interface SelectInputProps
  extends IFormInputLabelRequired,
    SelectHTMLAttributes<HTMLSelectElement> {
  isRequired?: boolean;
  validate?: Validator | Validator[];
  rows?: number;
  inputRef?: Ref<InputRef>;
  children: ReactNode;
  pleaseSelect?: ReactNode;
}

export const SelectInput = ({
  inputID,
  label,
  isRequired = true,
  validationDisabled,
  validate,
  children,
  pleaseSelect,
  ...rest
}: SelectInputProps) => {
  const validations = useMemo(() => {
    if (validationDisabled) {
      return undefined;
    }
    return combineReduxFormValidationRules(isRequired && required, validate);
  }, [validationDisabled, isRequired, validate]);

  return (
    <Field
      name={inputID}
      label={label}
      component={InputRenderer}
      validate={validations}
      type="select"
      {...rest}
    >
      {pleaseSelect ?? <PleaseSelect />}
      {children}
    </Field>
  );
};
